import styled from 'styled-components';

export const ImagesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0px auto 20px;
  position: relative;
  width: 100%;
  max-width: min(1440px, 100vw);
  padding: 0 20px 80px;
  gap: 20px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1200px) {
    gap: 16px;
    padding: 0 16px 60px;
  }

  @media (max-width: 767px) {
    gap: 0;
    margin: 0px auto 0px;
    padding: 0 16px 40px;
    justify-content: center;
  }
`;

export const ImagesDesktopWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 100%;

  @media (max-width: 1200px) {
    gap: 16px;
  }
`;

export const ImagesMobileSlider = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;

  .slick-slider {
    padding-bottom: 20px;
  }

  .slick-list {
    overflow: visible;
    padding: 0 !important;
  }

  .slick-track {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .slick-slide {
    /* Allow partial view of next slide */
    padding-right: 8px;
  }
`;

export const SliderImage = styled.img`
  width: 100%;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 16px;
  object-fit: cover;
  display: block !important;
  margin: 0 auto;
  /* Apply staggered offset based on prop */
  transform: ${props => props.offset === 'down' ? 'translateY(40px)' : 'translateY(0px)'};
  transition: transform 0.3s ease;
`;

export const StaggeredImage1 = styled.img`
  flex: 0 0 auto;
  width: 23%;
  max-width: 330px;
  min-width: 240px;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  transform: translateY(60px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(60px) scale(1.02);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1200px) {
    width: 22%;
    min-width: 200px;
    transform: translateY(40px);

    &:hover {
      transform: translateY(40px) scale(1.02);
    }
  }

  @media (max-width: 767px) {
    width: 45%;
    max-width: none;
    min-width: 140px;
    transform: translateY(40px);
    border-radius: 16px;
    
    &:hover {
      transform: translateY(40px) scale(1.02);
    }
  }
`;

export const StaggeredImage2 = styled.img`
  flex: 0 0 auto;
  width: 23%;
  max-width: 330px;
  min-width: 240px;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  transform: translateY(0px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(0px) scale(1.02);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1200px) {
    width: 22%;
    min-width: 200px;
  }

  @media (max-width: 767px) {
    width: 45%;
    max-width: none;
    min-width: 140px;
    transform: translateY(0px);
    border-radius: 16px;
    
    &:hover {
      transform: scale(1.02);
    }
  }
`;

export const StaggeredImage3 = styled.img`
  flex: 0 0 auto;
  width: 23%;
  max-width: 330px;
  min-width: 240px;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  transform: translateY(60px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(60px) scale(1.02);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1200px) {
    width: 22%;
    min-width: 200px;
    transform: translateY(40px);

    &:hover {
      transform: translateY(40px) scale(1.02);
    }
  }

  @media (max-width: 767px) {
    width: 45%;
    max-width: none;
    min-width: 140px;
    transform: translateY(40px);
    border-radius: 16px;
    
    &:hover {
      transform: translateY(40px) scale(1.02);
    }
  }
`;

export const StaggeredImage4 = styled.img`
  flex: 0 0 auto;
  width: 23%;
  max-width: 330px;
  min-width: 240px;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  transform: translateY(0px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(0px) scale(1.02);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1200px) {
    width: 22%;
    min-width: 200px;
  }

  @media (max-width: 767px) {
    width: 45%;
    max-width: none;
    min-width: 140px;
    transform: translateY(0px);
    border-radius: 16px;
    
    &:hover {
      transform: scale(1.02);
    }
  }
`;
